import React from 'react';
import styled from 'styled-components';

const InputWrap = styled.div`
  position: relative;
  input {
    border: 1px solid ${(props) => (props.error ? props.theme.colorUtilityError : props.theme.colorUI30)};
    height: ${({ theme }) => theme.formElementBaseHeight};
    font-size: ${({ theme }) => theme.fontSize03};
    border-radius: ${({ theme }) => theme.borderRadius};
    padding-left: ${({ theme }) => theme.spacing01};
    width: 100%;
  }

  .input-primary-error-text {
    color: red;
    font-size: 14px;
    margin-top: ${({ theme }) => theme.spacing01};
  }

  label {
    display: block;
    margin-bottom: ${({ theme }) => theme.spacing01};
    font-size: ${({ theme }) => theme.fontSize03};
    color: ${({ theme }) => theme.colorText50};
    font-weight: ${({ theme }) => theme.fontWeightMedium};
  }
`;

export default function Input({ label, onChange, value, error, placeholder }) {
  return (
    <InputWrap error={error} className="input-primary">
      <label>{label}</label>
      <input placeholder={placeholder} value={value} onChange={onChange} />
      {error ? <div className="input-primary-error-text">{error}</div> : null}
    </InputWrap>
  );
}
